import React from 'react';

const FilterTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="tabs-header">
      <div 
        className={`tab-item ${activeTab === 'all' ? 'active' : ''}`}
        onClick={() => setActiveTab('all')}
      >
        Todos
      </div>
      <div 
        className={`tab-item ${activeTab === 'master' ? 'active' : ''}`}
        onClick={() => setActiveTab('master')}
      >
        Master
      </div>
      <div 
        className={`tab-item ${activeTab === 'diretoria' ? 'active' : ''}`}
        onClick={() => setActiveTab('diretoria')}
      >
        Diretoria
      </div>
      <div 
        className={`tab-item ${activeTab === 'associado' ? 'active' : ''}`}
        onClick={() => setActiveTab('associado')}
      >
        Associado
      </div>
      <div 
        className={`tab-item ${activeTab === 'financeiro' ? 'active' : ''}`}
        onClick={() => setActiveTab('financeiro')}
      >
        Financeiro
      </div>
      <div 
        className={`tab-item ${activeTab === 'suporte' ? 'active' : ''}`}
        onClick={() => setActiveTab('suporte')}
      >
        Suporte
      </div>
    </div>
  );
};

export default FilterTabs;